import { IOfferDescriptionVisualParameter } from "./IOfferDescriptionVisualParameter";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 23.04.13
 * Time: 10:39
 */

import { BasicPrivateOfferVO } from "../../BasicPrivateOfferVO";
import { Constants_Offer } from "../../Constants_Offer";
import { PrivateOfferStateEnum } from "../../PrivateOfferStateEnum";

/**
 * Visual component to show a failed dialog if the offer comes to a failed state
 */
export class OfferDescriptionVisualFailedDialog implements IOfferDescriptionVisualParameter {
    private _dialogName: string;

    constructor(dialogName: string) {
        this._dialogName = dialogName;
    }

    public get name(): string {
        return Constants_Offer.OFFER_VISUAL_FAILED_DIALOG;
    }

    public parseFromObjectParam(params: any): void {
        this._dialogName = params.DN;
    }

    public execute(offerVO: BasicPrivateOfferVO): boolean {
        // show failed dialog with registered dialog name
        // OVERRIDE TO EXECUTE DIALOGHANDLER
        //BasicDialogHandler.getInstance().registerDialogs(_dialogName, new BasicPrivateOfferDialogProperties(offerVO));
        return true;
    }

    public toExecuteInState(state: PrivateOfferStateEnum): boolean {
        return PrivateOfferStateEnum.isFailedState(state);
    }

    public get dialogName(): string {
        return this._dialogName;
    }

    public dispose(): void {
        this._dialogName = null;
    }

    public getCommandName(): string {
        return "PRIVATE_OFFER_FAILED_DIALOG";
    }
}

